module.exports = __webpack_public_path__ + "img/Comorbidity_NASH.8136f829.jpg";